// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AsYVJ","swiper":"styles_swiper__uXBkn","imageWrapper":"styles_imageWrapper__pkIWM"};